import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { routeMetaData } from '../../constants/route-metadata.constant';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private router: Router) {}

  goToLogin(): void {
    this.router.navigate([routeMetaData.login.link]);
  }

  goToMyAccount(): void {
    this.router.navigate([routeMetaData.myAccount.link]);
  }
}
